import React from 'react'
import ToDoList from './components/ToDoList'

const App = () => {
  return (
    <>
    <ToDoList />
    </>
  )
}

export default App